module.exports = __webpack_public_path__ + "img/48.3a6fa91c.webp";